var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2943",
    d: "M0-682.665H14v14H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41436",
    "data-name": "Group 41436",
    transform: "translate(18882 7383)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15707",
    "data-name": "Rectangle 15707",
    width: 16,
    height: 16,
    transform: "translate(-18882 -7383)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2937",
    transform: "translate(-18881 -6699.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2939",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2941",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2947",
    transform: "translate(0.547 0.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2949",
    d: "M-151.494-417.916h-2.078a1.094,1.094,0,0,1-1.094-1.094v-6.562a1.094,1.094,0,0,1,1.094-1.094h10.719a1.094,1.094,0,0,1,1.094,1.094v6.563a1.094,1.094,0,0,1-1.094,1.094h-2.078",
    transform: "translate(154.666 426.666)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2951",
    transform: "translate(4.813 9.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2953",
    d: "M0,0,2.188,2.188,4.375,0",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2955",
    transform: "translate(7 6.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2957",
    d: "M0,0V4.922",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2959",
    transform: "translate(4.266 13.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2961",
    d: "M0,0H5.469",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2963",
    transform: "translate(0.836 3.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2965",
    d: "M0-270.451l4.524-5.663,1.641,1.641L7.8-276.114l4.524,5.663",
    transform: "translate(0 276.114)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadImage);
export default __webpack_public_path__ + "static/media/download-image.a289dc1fca7618131e07bf97878f0f3e.svg";
export { ForwardRef as ReactComponent };